import React, { useState } from "react";

import { handleSubmitSupportMessage } from "../../userDashboard/userControllers/profileController";
import Banner from "../components/Banner";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import landingAsset from "../utils/assetPaths";

import load from "./assets/load.gif";

interface ContactFormData {
    name: string;
    email: string;
    subject: string;
    phone: string;
    message: string;
}

const Contact: React.FC = () => {
    const [subject, setSubject] = useState("");
    const [body, setBody] = useState("");
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState<Record<string, string>>({});

    const validateFields = () => {
        const newErrors: Record<string, string> = {};
        if (!subject) newErrors.subject = "Reason is required";
        if (!body) newErrors.body = "Message body is required";
        if (!name) newErrors.name = "Full name is required";
        if (!email) newErrors.email = "Email address is required";
        if (!phone) newErrors.phone = "Phone number is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const onSuccess = () => {
        setLoading(false);
        setSubject("");
        setBody("");
        setEmail("");
        setName("");
        setPhone("");
    };

    const onError = () => {
        setLoading(false);
    };

    const handleSend = (e: React.MouseEvent) => {
        e.preventDefault();
        if (validateFields()) {
            setLoading(true);
            const userData: ContactFormData = {
                name,
                email,
                subject,
                phone,
                message: body,
            };
            handleSubmitSupportMessage(userData, onSuccess, onError);
        }
    };

    return (
        <>
            <Navbar />
            <div
                style={{
                    backgroundImage: `url(${landingAsset("herobg.svg")})`,
                    backgroundSize: "cover",
                }}
                className="h-[500px] md:h-[400px] relative w-full flex justify-center items-center flex-col "
            >
                <div
                    style={{
                        background:
                            "linear-gradient(180deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 17.83%)",
                    }}
                    className=" h-full w-full absolute left-0 top-0"
                >
                    <div className=" w-full h-full flex flex-col items-center text-center justify-center p-4">
                        <h1 className="text-white text-4xl md:text-5xl lg:text-6xl font-black font-Manrope uppercase tracking-tight">Contact Us</h1>
                        <p className=" mt-6 text-center font-Manrope text-lg md:text-xl text-white/90 max-w-3xl leading-relaxed">
                            Got Questions? We're Here to Assist - Your SACA Support Team is
                            Just a Pass Away. Reach out and we'll get back to you shortly.
                        </p>
                    </div>
                </div>
            </div>

            <div className="flex flex-col items-center py-24 w-full px-4 md:px-14 bg-gray-50">
                <div className="max-w-4xl w-full mx-auto">
                    <div className="bg-white p-8 md:p-16 rounded-[48px] shadow-2xl border border-gray-100">
                        <div className="mb-12">
                            <h2 className="text-3xl font-black text-gray-900 mb-4">Send a Message</h2>
                            <p className="text-gray-500 font-medium text-lg">Tell us how we can help you today.</p>
                        </div>

                        <form className="space-y-8">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                <div className="space-y-3">
                                    <label className="font-Manrope font-black text-gray-900 text-sm uppercase tracking-widest pl-1">Full Name</label>
                                    <input
                                        type="text"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        className="w-full bg-gray-50 border-2 border-transparent focus:border-green-700 focus:bg-white px-6 py-4 rounded-2xl font-Manrope font-bold text-gray-900 transition-all outline-none"
                                        placeholder="John Doe"
                                    />
                                    {errors.name && <p className="text-red-500 text-xs font-bold pl-1">{errors.name}</p>}
                                </div>
                                <div className="space-y-3">
                                    <label className="font-Manrope font-black text-gray-900 text-sm uppercase tracking-widest pl-1">Email Address</label>
                                    <input
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        className="w-full bg-gray-50 border-2 border-transparent focus:border-green-700 focus:bg-white px-6 py-4 rounded-2xl font-Manrope font-bold text-gray-900 transition-all outline-none"
                                        placeholder="john@example.com"
                                    />
                                    {errors.email && <p className="text-red-500 text-xs font-bold pl-1">{errors.email}</p>}
                                </div>
                            </div>

                            <div className="space-y-3">
                                <label className="font-Manrope font-black text-gray-900 text-sm uppercase tracking-widest pl-1">Phone Number</label>
                                <input
                                    type="tel"
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                    className="w-full bg-gray-50 border-2 border-transparent focus:border-green-700 focus:bg-white px-6 py-4 rounded-2xl font-Manrope font-bold text-gray-900 transition-all outline-none"
                                    placeholder="+234 800 000 0000"
                                />
                                {errors.phone && <p className="text-red-500 text-xs font-bold pl-1">{errors.phone}</p>}
                            </div>

                            <div className="space-y-3">
                                <label className="font-Manrope font-black text-gray-900 text-sm uppercase tracking-widest pl-1">Reason for Contact</label>
                                <input
                                    type="text"
                                    value={subject}
                                    onChange={(e) => setSubject(e.target.value)}
                                    className="w-full bg-gray-50 border-2 border-transparent focus:border-green-700 focus:bg-white px-6 py-4 rounded-2xl font-Manrope font-bold text-gray-900 transition-all outline-none"
                                    placeholder="Subscription Inquiry, Match Booking, etc."
                                />
                                {errors.subject && <p className="text-red-500 text-xs font-bold pl-1">{errors.subject}</p>}
                            </div>

                            <div className="space-y-3">
                                <label className="font-Manrope font-black text-gray-900 text-sm uppercase tracking-widest pl-1">Message</label>
                                <textarea
                                    value={body}
                                    rows={6}
                                    onChange={(e) => setBody(e.target.value)}
                                    className="w-full bg-gray-50 border-2 border-transparent focus:border-green-700 focus:bg-white px-6 py-4 rounded-2xl font-Manrope font-bold text-gray-900 transition-all outline-none resize-none"
                                    placeholder="How can we help you?"
                                />
                                {errors.body && <p className="text-red-500 text-xs font-bold pl-1">{errors.body}</p>}
                            </div>

                            <button
                                onClick={handleSend}
                                disabled={loading}
                                className="w-full bg-green-700 hover:bg-green-800 text-white py-5 rounded-2xl font-black text-xl transition-all shadow-xl hover:shadow-2xl active:scale-95 flex items-center justify-center gap-3 disabled:opacity-50"
                            >
                                {loading ? <img src={load} className="w-6 h-6" alt="Loading" /> : "Submit Message"}
                            </button>
                        </form>
                    </div>
                </div>
            </div>

            <Banner />
            <Footer />
        </>
    );
};

export default Contact;
